/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, NavLink, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import { ModalContext } from 'App';
import queryString from 'query-string';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import useDebounce from 'modules/common/hooks/useDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import Select from 'react-select';
import { reactSelectFilterStyle } from 'modules/common/components/Select';
import * as actions from '../action';
import * as c from '../constant';
import SubscriberContent from './SubscriberContent';
import ProfileEditModal from '../components/ProfileEditModal';
import AddSubscriberModal from '../components/AddSubscriberModal';
import ChangePasswordModal from '../components/ChangePasswordModal';
import MobuleTransactionListing from './MobuleTransactionListing';
import ChangePinModal from '../components/ChangePinModal';
import UpdatePinModalContainer from '../components/UpdatePinModalContainer';
import UpdateMobileNumberModal from '../components/UpdateMobileNumberModal';
import UpdateEmailModal from '../components/UpdateEmailModal';

import CmsContext from '../../../context/CmsContext';

const INIT_FILTER = {
  module_type: 'PSA',
  transaction_type: 'BIRTH CERTIFICATE',
  sort_by: 'desc',
  q: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  is_resident: '',
  verification_status: '',
};

const options = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Resident',
    value: 1,
  },
  {
    label: 'Non-Resident',
    value: 0,
  },
];

const verificationStatusOptions = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Verified',
    value: 'VERIFIED',
  },
  {
    label: 'Unverified',
    value: 'UNVERIFIED',
  },
  {
    label: 'Pending',
    value: 'PENDING',
  },
];

const FilterByIsResident = ({ value, ...rest }) => (
  <>
    <label className="form-label mt-2 mb-0 text-muted mr-1">
      <h6>Filter By Status</h6>
    </label>
    <Select
      value={
        options.find((item) => `${value}` === `${_.get(item, 'value')}`) || ''
      }
      styles={reactSelectFilterStyle}
      options={options}
      {...rest}
    />
  </>
);

const FilterByVerificationStatus = ({ value, ...rest }) => (
  <>
    <label className="form-label mt-2 mb-0 text-muted ml-3 mr-1">
      <h6>Filter By Verification Status</h6>
    </label>
    <Select
      value={
        verificationStatusOptions.find(
          (item) => `${value}` === `${_.get(item, 'value')}`
        ) || ''
      }
      styles={reactSelectFilterStyle}
      options={verificationStatusOptions}
      {...rest}
    />
  </>
);

const CustomFilterContainer = ({ filter, handleOnChangeSelect }) => (
  <div className="d-flex align-items-center justify-content-end my-3">
    <FilterByIsResident
      value={_.get(filter, 'is_resident')}
      onChange={(e) => handleOnChangeSelect(e, 'is_resident')}
    />
    <FilterByVerificationStatus
      value={_.get(filter, 'verification_status')}
      onChange={(e) => handleOnChangeSelect(e, 'verification_status')}
    />
  </div>
);

FilterByIsResident.propTypes = {
  value: PropTypes.string.isRequired,
};

function SubscriberContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
  taxpayer,
  activateProfile,
  activating,
  permissions,
  approving,
  rejecting,
  approveVerification,
  rejectVerification,
  getReportAccess,
}) {
  const setModal = useContext(ModalContext);
  const [filter, setFilter] = useState(INIT_FILTER);
  const selectedTransaction = match.params.id;
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const authProfile = getJson('profile') || {};
  const debouncedSearchTerm = useDebounce(filter, 500);
  const photo = _.get(taxpayer, 'attributes.photo') || false;

  const handleNavigate = (id) => {
    if (id) {
      history.push(`/subscribers/${id}`);
    }
  };

  const getData = () => {
    getTransactionList(debouncedSearchTerm, ({ data }) =>
      handleNavigate(_.get(data, '0.id'))
    );
  };

  useEffect(() => {
    getData();
  }, [JSON.stringify(debouncedSearchTerm)]);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      showTransaction(selectedTransaction);
    }

    return () => {
      setModal({ isOpen: false });
    };
  }, [selectedTransaction]);

  const handleActivate = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to activate this user?',
      () => {
        activateProfile(selectedTransaction, {}, () => {
          getData();
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
      page: 1,
    }));
  };

  const handleOnChangeSelect = (e, key) => {
    setFilter((prev) => ({
      ...prev,
      [key]: e.value,
    }));
  };

  const handleVerifyOtp = () => {
    // e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdatePinModalContainer
          taxPayerId={selectedTransaction}
          mobileNo={_.get(taxpayer, 'attributes.new_mobile_number')}
        />
      ),
      title: 'Enter OTP for this mobile number',
      modalSize: 'modal-md',
    });
  };

  const handleEditProfile = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ProfileEditModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
          handleVerifyOtp={handleVerifyOtp}
        />
      ),
      title: 'Update Subscriber Account',
      modalSize: 'modal-xl',
    });
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangePasswordModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
        />
      ),
      title: 'Change Password',
      modalSize: 'modal-md',
    });
  };

  const handleChangePin = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangePinModal taxpayers={taxpayer} taxpayerId={selectedTransaction} />
      ),
      title: 'Change Pin',
      modalSize: 'modal-md',
    });
  };

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'WAITING FOR PAYMENT',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleApproveVerification = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to approve this subscriber?',
      (remarks) => {
        approveVerification(
          data,
          {
            remarks,
          },
          () => {
            showTransaction(data);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleRejectVerification = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to reject this subscriber?',
      (remarks) => {
        rejectVerification(
          data,
          {
            remarks,
          },
          () => {
            showTransaction(data);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleAddAccount = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddSubscriberModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
        />
      ),
      title: 'Add Subscriber Account',
      modalSize: 'modal-md',
    });
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'FOR APPEARANCE',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const downloadCSV = (e) => {
    e.preventDefault();

    const reportAccessArgs = {
      path: `api/v1/administrators/subscribers/export_csv`,
      query: {
        ...queryString.parse(window.location.search),
        ...filter,
        email: _.get(authProfile, 'email'),
        module_type: 'CITIZEN',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  const handleUpdateMobileNumber = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateMobileNumberModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
        />
      ),
      title: 'Update Mobile Number',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateEmail = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateEmailModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
        />
      ),
      title: 'Update Email',
      modalSize: 'modal-md',
    });
  };

  return (
    <>
      {Acl(permissions, ['ADD SUBSCRIBER']) && (
        <div className="row d-flex justify-content-end mr-3">
          <button
            onClick={handleAddAccount}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  mt-2"
            type="button"
          >
            Add Subscriber Account
          </button>
        </div>
      )}
      <div className="card-content-listing">
        <Route
          path={`${match.path}`}
          render={({ match: { params } }) => {
            return (
              <GenericListPair
                customFilter={
                  <CustomFilterContainer
                    filter={filter}
                    handleOnChangeSelect={handleOnChangeSelect}
                  />
                }
                downloadCSV={downloadCSV}
                moduleName={`${
                  _.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
                    ? 'Registrants/ Subscribers'
                    : 'Subscribers List'
                }`}
                setKeyword={handleOnChange}
                setStatusFilter={(e) =>
                  handleOnChangeSelect(e, 'transaction_status')
                }
                status={_.get(filter, 'transaction_status') || ''}
                keyword={_.get(filter, 'q') || ''}
                keywordPlaceholder="Search Subscriber..."
                listName="Subscriber"
                label="Basic Information"
                renderItem={(item) => (
                  <div className="px-3 py-3">
                    <div className="transaction-list-company">
                      {(
                        _.get(item, 'attributes.first_name') || '---'
                      ).toUpperCase()}
                      &nbsp;
                      {(
                        _.get(item, 'attributes.middle_name') || ''
                      ).toUpperCase()}
                      &nbsp;
                      {(
                        _.get(item, 'attributes.last_name') || ''
                      ).toUpperCase()}
                      &nbsp;
                      {(
                        _.get(item, 'attributes.extension_name') || ''
                      ).toUpperCase()}
                    </div>
                    {_.get(item, 'attributes.is_user_id_auth') === 0 && (
                      <h4 className="mt-1 mb-0 transaction-list-name">
                        {_.get(item, 'attributes.mobile_number') || '---'}
                      </h4>
                    )}
                    {_.get(item, 'attributes.is_user_id_auth') === 1 && (
                      <h4 className="mt-1 mb-0 transaction-list-name">
                        {_.get(item, 'attributes.user_id') || '---'}
                      </h4>
                    )}
                  </div>
                )}
                isLoading={isLoading}
                selected={params.id}
                data={transactionList}
                dataPager={transactionListPager}
                handleSelectRow={(data) => handleNavigate(_.get(data, 'id'))}
                renderContent={() => (
                  <div className="px-4">
                    {selectedTransaction ? (
                      <>
                        <div className="row name-banner">
                          <div className="p-0 d-flex flex-nowrap w-100 pb-2">
                            <div className="d-flex ml-auto">
                              {!_.get(taxpayer, 'attributes.is_active') && (
                                <button
                                  disabled={activating}
                                  onClick={handleActivate}
                                  type="button"
                                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                                >
                                  {activating ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp; Loading
                                    </>
                                  ) : (
                                    'Activate'
                                  )}
                                </button>
                              )}
                              {Acl(permissions, ['CITIZEN EDIT']) && (
                                <button
                                  // disabled={activating}
                                  onClick={handleApproveVerification(
                                    selectedTransaction
                                  )}
                                  type="button"
                                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                                >
                                  {approving ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp; Loading
                                    </>
                                  ) : (
                                    'Approve Verification'
                                  )}
                                </button>
                              )}
                              {Acl(permissions, ['CITIZEN EDIT']) && (
                                <button
                                  // disabled={activating}
                                  onClick={handleRejectVerification(
                                    selectedTransaction
                                  )}
                                  type="button"
                                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                                >
                                  {rejecting ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp; Loading
                                    </>
                                  ) : (
                                    'Reject Verification'
                                  )}
                                </button>
                              )}

                              {Acl(permissions, [
                                'CITIZEN CHANGE PASSWORD',
                              ]) && (
                                // _.get(taxpayer, 'attributes.is_user_id_auth') === 0 &&
                                <button
                                  // disabled={activating}
                                  onClick={handleChangePassword}
                                  type="button"
                                  className="btn btn-secondary cms-bg-color-secondary cms-outline-secondary"
                                >
                                  {activating ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp;
                                    </>
                                  ) : (
                                    'Change Password'
                                  )}
                                </button>
                              )}
                              {Acl(permissions, ['CITIZEN CHANGE PIN']) &&
                                _.get(
                                  taxpayer,
                                  'attributes.is_user_id_auth'
                                ) === 1 && (
                                  <button
                                    // disabled={activating}
                                    onClick={handleChangePin}
                                    type="button"
                                    className="btn btn-secondary"
                                  >
                                    {activating ? (
                                      <>
                                        <i className="fa fa-spin fa-spinner" />{' '}
                                        &nbsp;
                                      </>
                                    ) : (
                                      'Change Pin'
                                    )}
                                  </button>
                                )}
                            </div>
                          </div>
                          <div className="p-0 d-flex flex-nowrap w-100 pb-2">
                            <div className="d-flex ml-auto">
                              {Acl(permissions, ['CITIZEN EDIT']) && (
                                <button
                                  // disabled={activating}
                                  onClick={handleEditProfile}
                                  type="button"
                                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                                >
                                  {activating ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp; Loading
                                    </>
                                  ) : (
                                    'Edit Profile'
                                  )}
                                </button>
                              )}
                              {Acl(permissions, ['UPDATE SUBSCRIBER MOBILE NUMBER']) && (
                                <button
                                  onClick={handleUpdateMobileNumber}
                                  type="button"
                                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                                >
                                  {approving ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp; Loading
                                    </>
                                  ) : (
                                    'Update Mobile Number'
                                  )}
                                </button>
                              )}
                              {Acl(permissions, ['UPDATE SUBSCRIBER EMAIL']) && (
                                <button
                                  onClick={handleUpdateEmail}
                                  type="button"
                                  className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                                >
                                  {approving ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp; Loading
                                    </>
                                  ) : (
                                    'Update Email'
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="name-image-inner">
                            <div className="image-name-wrap">
                              {photo && photo !== '-/format/jpeg/' ? (
                                <img
                                  className="round-img"
                                  alt="Client Profile"
                                  src={_.get(taxpayer, 'attributes.photo')}
                                />
                              ) : (
                                <img
                                  className="round-img"
                                  alt="Client Profile"
                                  src={ImagePlaceholder}
                                />
                              )}
                            </div>
                            <div className="name-banner-name">
                              {`${(
                                _.get(taxpayer, 'attributes.first_name') ||
                                '---'
                              ).toUpperCase()} ${(
                                _.get(taxpayer, 'attributes.middle_name') || ''
                              ).toUpperCase()} ${(
                                _.get(taxpayer, 'attributes.last_name') || ''
                              ).toUpperCase()} ${(
                                _.get(taxpayer, 'attributes.extension_name') ||
                                ''
                              ).toUpperCase()}`}
                            </div>
                          </div>
                        </div>
                        <SideScrollingTab dragToScroll>
                          <ul className="nav nav-tabs subscriber-tab">
                            <li className="nav-item">
                              <NavLink
                                exact
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}?`}
                              >
                                Profile
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/birth-certificates`}
                              >
                                Birth Certificates
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/cedulas`}
                              >
                                Cedulas
                              </NavLink>
                            </li>
                            {/* <li className="nav-item">
                            <NavLink
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}/occupational-and-healths`}
                            >
                              Occupational & Healths
                            </NavLink>
                          </li> */}
                            {/* <li className="nav-item">
                            <NavLink
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}/rptax`}
                            >
                              RPTAX
                            </NavLink>
                          </li> */}
                            {/* <li className="nav-item">
                            <NavLink
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}/btax`}
                            >
                              BTAX
                            </NavLink>
                          </li> */}
                            {/* <li className="nav-item">
                            <NavLink
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}/nov`}
                            >
                              NOV
                            </NavLink>
                          </li> */}
                            {/* <li className="nav-item">
                            <NavLink
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}/ovrs`}
                            >
                              OVRS
                            </NavLink>
                          </li> */}
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/bpls`}
                              >
                                BPLS
                              </NavLink>
                            </li>
                            {/* <li className="nav-item">
                            <NavLink
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}/t_bpls`}
                            >
                              E-Boss
                            </NavLink>
                          </li> */}
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/death-certificates`}
                              >
                                Death Certificates
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/marriage-certificates`}
                              >
                                Marriage Certificates
                              </NavLink>
                            </li>
                          </ul>
                        </SideScrollingTab>
                        <Switch>
                          <Route
                            exact
                            path="/subscribers"
                            render={() =>
                              !params.id && transactionList.length > 0 ? (
                                <Redirect
                                  to={`/subscribers/${_.get(
                                    transactionList,
                                    '0.id'
                                  )}`}
                                />
                              ) : null
                            }
                          />
                          <Route
                            exact
                            path="/subscribers/:id"
                            render={() => (
                              <SubscriberContent
                                onApprove={handleApprove}
                                onReject={handleReject}
                              />
                            )}
                          />
                          <Route
                            path="/subscribers/:id/:transaction_type"
                            component={MobuleTransactionListing}
                          />
                        </Switch>
                      </>
                    ) : (
                      <h4 className="text-center font-weight-bold text-muted p-5">
                        No Selected Transactions
                      </h4>
                    )}
                  </div>
                )}
                handleChangePage={(page) =>
                  setFilter((prev) => ({ ...prev, page }))
                }
              />
            );
          }}
        />
      </div>
    </>
  );
}

SubscriberContainer.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  activating: PropTypes.bool.isRequired,
  activateProfile: PropTypes.instanceOf(Function).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  approving: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  approveVerification: PropTypes.instanceOf(Function).isRequired,
  rejectVerification: PropTypes.instanceOf(Function).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  approving: api.loading.indexOf(c.APPROVE_VERIFICATION) > -1,
  rejecting: api.loading.indexOf(c.REJECT_VERIFICATION) > -1,
  activating: api.loading.indexOf(c.ACTIVATE_PROFILE) > -1,
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item`) || {}),
    } || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SubscriberContainer);
